import React from 'react';
var PluginContext = /*#__PURE__*/React.createContext();
export default PluginContext;